import { Api } from '@axiom/ui';
import type { Candidate, CandidateProfileHighlights } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class CandidateProfileHighlightsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
      cookieDomain: EnvUtil.cookieDomain,
    });
  }

  readProfileHighlights(id: Candidate['id']) {
    return super.read<{ data: CandidateProfileHighlights }>({
      endpoint: `/candidates/${id}/profileHighlights`,
      method: 'GET',
    });
  }

  async refreshProfileHighlights(id: Candidate['id']) {
    return super.invalidate(`/candidates/${id}/profileHighlights`);
  }
}

export const CandidateProfileHighlightsApi =
  new CandidateProfileHighlightsApiClass();
